import { DEFAULT_DATE } from '../utilities/constants';
import { getValueFromLocalStorage } from '../utilities/utilityFunctions';
import { client, gql } from './Client';

const deficiencyFilesQuery = gql`
  query deficiencyFilesFeed(
    $siteId: Int!
    $disciplineId: Int!
    $lastModified: DateTime!
    $isLeadInspector: Boolean!
  ) {
    deficiencyFilesFeed(
      siteId: $siteId
      disciplineId: $disciplineId
      lastModified: $lastModified
      isLeadInspector: $isLeadInspector
    ) {
      fileAimsUUID
      isDelete
      siteId
      disciplineId
      isActiveDeficiencyFile
    }
  }
`;

const deficiencyFiles = (siteId: number, disciplineId: number) =>
  client.query({
    query: deficiencyFilesQuery,
    variables: {
      siteId,
      disciplineId,
      lastModified: DEFAULT_DATE,
      isLeadInspector: getValueFromLocalStorage('isLeadInspector') === 'True',
    },
  });

export { deficiencyFiles };
